module.exports = __webpack_public_path__ + "static/fonts/Montserrat-ExtraBoldItalic.52a50ca.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat-ExtraBoldItalic.ttf
// module id = iS4Q
// module chunks = 1